import React, { useState, useEffect } from 'react'
import { Button, Col, Row } from 'reactstrap';
import handleNavbarTransparency from '../../../helpers/handleNavbarTransparency';
import bg1 from '../../../assets/img/generic/condominium.jpg';
import Section from '../../common/Section';
import NumberFormat from 'react-number-format';
import { faCalculator } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { getConfigAsRoot } from '../../../helpers/api/root';
import { getErrorMessage } from '../../../helpers/errors/handleErrorMessage';
import { isIterableArray } from '../../../helpers/utils';

const Calculator = () => {

    const [properties, setProperties] = useState(null);
    const [total, setTotal] = useState(null);
    const [prices, setPrices] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        window.addEventListener('scroll', handleNavbarTransparency);
        return () => window.removeEventListener('scroll', handleNavbarTransparency);
    }, []);

    useEffect(() => {
        let isMounted = true;
        if (!prices) {
            isMounted && setLoading(true);
            getConfigAsRoot()
                .then(({ data }) => { isMounted && setPrices(data); })
                .catch((error) => { console.log(getErrorMessage(error.code)) })
                .finally(() => isMounted && setLoading(false));
        }
        return () => { isMounted = false; }
    }, [prices])

    const setPrice = () => {
        if (properties) {
            let array = prices?.filter(val => properties >= val.min && properties <= val.max);
            let arrayPrice = array?.find(val => properties >= val.min && properties <= val.max);
            setTotal(arrayPrice?.price ? arrayPrice.price : 'Out of range');
        }
    }

    return <>
        <Section id='calculator' className="py-0 overflow-hidden" image={bg1} position="center bottom" overlay>
            <Row className="justify-content-center align-items-center pt-8 pt-lg-10 pb-lg-9 pb-xl-0">
                <Col md={12} lg={12} xl={12} className="pb-9 pb-xl-9 text-center text-xl-left">
                    <h1 className="text-white text-center font-weight-bolder">
                        ¡Calcula que servicio va mejor con tus necesidades!
                    </h1>
                    <p className="lead text-white text-center opacity-75">
                        Calcula un aproximado del monto a pagar ingresando el número de propiedades en tu condominio.
                    </p>
                    {total && total !== 0 && total !== '0' && total !== 'Out of range' ? <h3 className='text-white font-weight-bolder'>
                        <NumberFormat thousandSeparator prefix='$ ' value={total} decimalScale={2} fixedDecimalScale displayType='text' suffix=" por propiedad" />
                        <span className='d-block'>Por el servicio</span>
                        <NumberFormat thousandSeparator prefix='$ ' value={total*properties} decimalScale={2} fixedDecimalScale displayType='text' suffix=" en total" />
                    </h3> : ''}
                    {total === 'Out of range' ? <h3 className='text-white text-center font-weight-bolder'>
                        <span className='d-block'>Número de propiedades fuera del rango disponible.</span>
                    </h3> : ''}
                </Col>
     {/*            <Col xl={{ size: 7, offset: 1 }} className="pb-9 pb-xl-9">
                    <h2 className="text-white font-weight-light mb-4">Ingresa el número de propiedades de tu condominio</h2>
                    <NumberFormat value={properties} onKeyDown={({ key }) => {
                        if (key === 'Enter') {
                            setPrice()
                        }
                    }} onChange={({ target }) => target.value === '' && setTotal(null)} onValueChange={({ value }) => setProperties(value)} className='rounded-capsule border-2x  bg-transparent pt-4 pb-4 fs-1 text-white form-control' suffix=' Propiedades' thousandSeparator decimalScale={0} placeholder='Ingresa el número de propiedades' />
                    <Button color='light' disabled={loading || !isIterableArray(prices)} outline className="border-2x rounded-pill bg-transparent btn-lg mt-4 fs-0 py-2" onClick={setPrice}>
                        <FontAwesomeIcon icon={faCalculator} className='mr-1' />
                        {isIterableArray(prices) ? 'Calcular' : 'No disponible'}
                    </Button>
                </Col> */}
            </Row>
        </Section>
    </>
}

export default Calculator;